import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { getRequestNonprofitPath } from '../requestNonprofitLink'

import { Anchor } from '@percent/lemonade'
import { useAuth } from '@percent/workplace-giving/common/hooks'
import { useAnalytics } from '@percent/workplace-giving/common/hooks/useAnalytics/useAnalytics'
import { useColorTheme } from '@percent/workplace-giving/common/hooks/useColorTheme/useColorTheme'
import { getAccountFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

type RequestNonprofitFooterProps = Readonly<{
  searchText: string
  countryCode: string
  eventOrigin: string
}>

export function RequestNonprofitFooter({ searchText, countryCode, eventOrigin }: RequestNonprofitFooterProps) {
  const { t } = useTranslation()
  const { track } = useAnalytics()
  const { state } = useAuth()
  const account = getAccountFromAuthState(state)
  const { theme } = useColorTheme()
  const [lastSearchText, setLastSearchText] = useState(searchText)

  useEffect(() => {
    if (searchText) setLastSearchText(searchText)
  }, [searchText])

  const trackRequestNonprofitOpened = () => {
    track({
      event: 'Request Nonprofit Validation Form Opened',
      properties: {
        userId: account?.id,
        origin: eventOrigin
      }
    })
  }

  return (
    <>
      {t('workplace_giving.common.cantFindANonprofit')}{' '}
      <Anchor
        component={Link}
        to={getRequestNonprofitPath({ name: lastSearchText, countryCode })}
        onClick={trackRequestNonprofitOpened}
        c={theme.primary400}
        underline="always"
        fz="inherit"
        lh="inherit"
      >
        {t('workplace_giving.common.submitARequest')}
      </Anchor>
    </>
  )
}
